import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enLinkText from '@linktivity/link-ui/lang/en';
import jaLinkText from '@linktivity/link-ui/lang/ja';
import koLinkText from '@linktivity/link-ui/lang/ko';
import zhLinkText from '@linktivity/link-ui/lang/zh';
import ztLinkText from '@linktivity/link-ui/lang/zt';
import { isWechat } from '@triplabo/web/utils/env';
import en from './lang/en';
import ja from './lang/ja';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';

export const DEFAULT_LOCALE = 'en';
export const LOCALE_LIST = ['en', 'ja', 'ko', 'zh', 'zt'];

const FALLBACK_LOCALE = isWechat ? 'zh' : DEFAULT_LOCALE;

export const LOCALE_MAP: Record<string, string> = {
  en_US: 'en',
  ja_JP: 'ja',
  zh_CN: 'zh',
  zh_TW: 'zt',
  ko_KR: 'ko'
};

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  en: {
    translation: {
      ...enLinkText,
      ...en
    }
  },
  ja: {
    translation: {
      ...jaLinkText,
      ...ja
    }
  },
  zh: {
    translation: {
      ...zhLinkText,
      ...zh
    }
  },
  zt: {
    translation: {
      ...ztLinkText,
      ...zt
    }
  },
  ko: {
    translation: {
      ...koLinkText,
      ...ko
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources
});

export function setLocale(locale: string): string {
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale);
  localStorage.setItem('locale', locale);
  return locale;
}

export function resetLocale() {
  localStorage.removeItem('locale');
  void i18n.changeLanguage(FALLBACK_LOCALE);
  document.documentElement.setAttribute('lang', FALLBACK_LOCALE);
}

function getLocaleParams() {
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get('lang') || '';
  if (LOCALE_LIST.includes(lang)) {
    return lang;
  }

  if (Object.keys(LOCALE_MAP).includes(lang)) {
    return LOCALE_MAP[lang];
  }
}

(() => {
  const defaultLocale =
    getLocaleParams() || localStorage.getItem('locale') || FALLBACK_LOCALE;
  setLocale(defaultLocale);
})();

export default i18n;
